import { Component } from 'react';
import classnames from 'classnames';
import classBind from 'classnames/bind';

import styles from './styles.scss';

let cx = classBind.bind(styles);

export default class TabNav extends Component {
  render() {
    const style = this.props.style;
    let className = cx({
      tabNav: true,
      [`${style}`]: style || false,
      justified: this.props.justified,
    });

    return (
      <div className={classnames(className)}>
        <div className="container">
          <div className="col">{this.props.children}</div>
        </div>
      </div>
    );
  }
}
